import { FunctionComponent } from 'react';
import { Toast } from '@shopify/polaris';
import {
  notificationErrorSelector,
  notificationErrorState,
  notificationSuccessState,
} from '@states';
import { useRecoilState, useRecoilValue } from 'recoil';

const ToastMessage: FunctionComponent = () => {
  const [, setNotificationError] = useRecoilState(notificationErrorState);
  const notificationError = useRecoilValue(notificationErrorSelector);
  const [notificationSuccess, setNotificationSuccessState] = useRecoilState(
    notificationSuccessState,
  );

  return (
    <>
      {notificationError && (
        <Toast
          content={notificationError}
          error
          onDismiss={() => setNotificationError(undefined)}
        />
      )}
      {notificationSuccess && (
        <Toast
          content={notificationSuccess}
          onDismiss={() => setNotificationSuccessState(undefined)}
        />
      )}
    </>
  );
};

export default ToastMessage;
